import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=22c68fd8&scoped=true&lang=pug"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
import style0 from "./Points.vue?vue&type=style&index=0&id=22c68fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c68fd8",
  null
  
)

export default component.exports